import { useState } from "react";
import { daysAgo } from "@demandproai/shared";
import { COMPANY_STATUS } from "@demandproai/shared";

const useCompanyFilter = ({ filterConfig }) => {
    const today = new Date();
    const defaultDaysAgo = daysAgo(7);

    const [selectedRange, setSelectedRange] = useState({ startDate: defaultDaysAgo, endDate: today });
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isOpenDateRange, setIsOpenDateRange] = useState(false);
    const [selectedTiers, setSelectedTiers] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([COMPANY_STATUS.SUBSCRIBED, COMPANY_STATUS.ALACARTE]);
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [selectedAccountExecutive, setSelectedAccountExecutive] = useState([]);

    const resetFilters = () => {
        setSelectedTiers([]);
        setSelectedStatus([]);
        setSelectedAccountExecutive([]);
        setSelectedCompanies([]);
        setSelectedRange({ startDate: defaultDaysAgo, endDate: today });
        setIsFilterOpen(false)
    };

    const filterParams = {
        selectedRange,
        selectedTiers,
        selectedStatus,
        selectedAccountExecutive,
        selectedCompanies,
    };

    const isAnyFilterApplied =
        (selectedStatus && selectedStatus.length > 0) ||
        (selectedTiers && selectedTiers.length > 0) ||
        (selectedAccountExecutive && selectedAccountExecutive.length > 0) ||
        (selectedCompanies && selectedCompanies.length > 0) ||
        (selectedRange?.startDate && selectedRange?.endDate);

    return {
        filterParams,
        filterConfig,
        isFilterOpen,
        isOpenDateRange,
        isAnyFilterApplied,
        setIsFilterOpen,
        setIsOpenDateRange,
        setSelectedRange,
        setSelectedTiers,
        setSelectedStatus,
        setSelectedCompanies,
        setSelectedAccountExecutive,
        resetFilters,
        selectedRange
    };
};

export default useCompanyFilter;
